import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Tooltip, Typography } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import DelaStarCalculatingIcon from '~/modules/common/components/Icons/Objects/DelaStarCalculatingIcon';
import { useGetAttachmentInfo } from '../hooks';
import DelaLoadingTooltip from './DelaLoadingTooltip';

const useTooltipStyles = makeStyles(theme => ({
  tooltip: {
    borderRadius: theme.spacing(2)
  }
}));

const useStyles = makeStyles(theme => ({
  tooltipSpan: {
    display: 'flex',
    gap: theme.spacing(0.5)
  }
}));

const title = <DelaLoadingTooltip />;

export const DelaAttachmentStatus = ({ attachment, setShowDelaBanner }) => {
  const tooltipClasses = useTooltipStyles();
  const classes = useStyles();
  const { processed, notifyUser } = useGetAttachmentInfo({
    binaryObjectUri: attachment.uploadUri
  });

  useEffect(() => {
    if (processed && notifyUser && setShowDelaBanner) {
      setShowDelaBanner(true);
    }
  }, [setShowDelaBanner, processed, notifyUser]);

  return (
    !processed && (
      <Tooltip classes={tooltipClasses} placement="bottom-end" title={title}>
        <span className={classes.tooltipSpan}>
          <DelaStarCalculatingIcon />
          <Typography variant="body2" color="textSecondary">
            <FormattedMessage id="attachments.analyzingDocument" />
          </Typography>
        </span>
      </Tooltip>
    )
  );
};

DelaAttachmentStatus.propTypes = {
  attachment: PropTypes.object.isRequired,
  setShowDelaBanner: PropTypes.func
};

export default DelaAttachmentStatus;
